module.exports = __webpack_public_path__ + "img/cdman.bfdaf961.png";